import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'src/common/refactoredComponents/button/Button';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import { ButtonStyles } from 'src/constants/buttonStyles';
import ExportIcon from 'src/assets/images/Export.svg';
import {
    ResultsHeaderRow,
    ResultsLeft,
    ResultsCount,
    ResultsRight,
    ExportIconImg,
    ExportSpinnerWrapper,
    DesktopFilterPanelWrapper,
    MobileFilterPanelWrapper,
} from './index.styled';
import { isMobileView } from 'src/utils/util';
import FilterResultsPanel from 'src/common/organisms/filterResultsPanel/FilterResultsPanel';

/**
 * ConsignedResultsHeader (SCAFFOLD)
 * Results count + Export / Expand All actions. Styled to match the Field
 * Inventory Dashboard results row (common Button + Export icon).
 * TODO(team): wire Export (download) and Expand All (toggle) handlers and
 * replace hard-coded labels with i18n keys.
 */
const ConsignedResultsHeader = ({
    resultsCount = 0,
    onExport = () => {},
    loadingExport = false,
    consignedAppliedFilters = [],
    onClearFilters = () => {},
    onOpenFilters = () => {},
}) => {

    const isMobile = isMobileView();
    const { t } = useTranslation();
    
    return (
        <ResultsHeaderRow id="consigned-results-row">
            <ResultsLeft id="consigned-results-row-left">
                <ResultsCount id="consigned-results-count" fontSize={'18px'}>
                    {t('calendar.orders.searchResultsPanel.resultsLabel')} {`(${resultsCount})`}
                </ResultsCount>
                {!isMobile && consignedAppliedFilters.length > 0 && (
                    <DesktopFilterPanelWrapper>
                        <FilterResultsPanel
                            id="more-consigned-inventory-filter-results-panel"
                            appliedFilters={consignedAppliedFilters}
                            clearFilterHandler={onClearFilters}
                            fimDashboardFilterResultsPanel={true}
                            noExtraBorder={true}
                            backgroundColor="transparent"
                            onMoreClick={onOpenFilters}
                        />
                    </DesktopFilterPanelWrapper>
                )}
            </ResultsLeft>
            {isMobile && consignedAppliedFilters.length > 0 && (
                <MobileFilterPanelWrapper>
                    <FilterResultsPanel
                        id="more-consigned-inventory-filter-results-panel"
                        appliedFilters={consignedAppliedFilters}
                        clearFilterHandler={onClearFilters}
                        fimDashboardFilterResultsPanel={true}
                        noExtraBorder={true}
                        backgroundColor="transparent"
                        mobileBackgroundColor="transparent"
                        filterContainerMobilePadding="0"
                        widthTemplate={true}
                        marginLeftTemplate={true}
                        marginTop={'0px'}
                        onMoreClick={onOpenFilters}
                    />
                </MobileFilterPanelWrapper>
            )}
            {resultsCount > 0 && (
            <ResultsRight id="consigned-results-row-right">
                <Button
                    id="consigned-export-btn"
                    clicked={onExport}
                    disabled={loadingExport}
                    variant={ButtonStyles.secondary}
                    borderRadius="20px"
                    height="32px"
                    minWidth={isMobile ? undefined : '110px'}
                    width={isMobile ? undefined : '110px'}
                    fontSize="14px"
                    fontFamily="AvenirNextWorld Demi"
                >
                    {loadingExport ? (
                        <ExportSpinnerWrapper>
                            <Spinner
                                id="consigned-export-loading-spinner"
                                animation="border"
                                variant="primary"
                                small
                            />
                        </ExportSpinnerWrapper>
                    ) : (
                        <>
                            <ExportIconImg
                                id="consigned-export-icon"
                                src={ExportIcon}
                                alt="export"
                            />
                            {t('receiveSets.InventoryConsigned.export')}
                        </>
                    )}
                </Button>
            </ResultsRight>
            )}
        </ResultsHeaderRow>
    );
};

export default ConsignedResultsHeader;
